// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/blog/_index.scss
// module id = 60
// module chunks = 0